export function salonjobsIntroLines(
  about: string | null | undefined,
  topCatch: string | null | undefined,
): string[] {
  return (about || topCatch || "").split("\n").filter(Boolean);
}
